

<form class="form" [formGroup]="form" autocomplete="off" *ngIf="contentType != null">
        
    <!-- IF INPUT (string) -->
    <div class="input-data-edit" *ngIf="contentType == attrType.input && contentValueType == attrValueType.string" >
        
        <div class="form-group">
            <input *ngIf="defaultStyle" class="form-control input-edit" [ngClass]="{'input-edit-window': !defaultStyle}" placeholder="Введите значение" type="text" formControlName="value" (keydown.enter)="updateList()"/>
            <input *ngIf="!defaultStyle" class="form-control input-edit" [ngClass]="{'input-edit-window': !defaultStyle}" placeholder="Введите значение" type="text" formControlName="value" (keydown.enter)="updateList()" (change)="updateList()"/>
        </div>

        <div class="action-input" *ngIf="defaultStyle">
            <!-- <span class="action-field" *ngIf="defaultStyle"><i class="bi bi-x-circle reject" (click)="closeAction()"></i></span> -->
            <span class="action-field" (click)="updateList()">
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject" (click)="closeAction()">
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <!-- <span class="action-field"><i class="bi bi-check-circle approve" (click)="updateList()"></i></span> -->
        </div>
    </div>

    <!-- IF INPUT (integer) -->
    <div class="input-data-edit" *ngIf="contentType == attrType.input && (contentValueType == attrValueType.numeric || contentValueType == attrValueType.integer)">
        
        <div class="form-group">
            <input class="form-control input-edit" [ngClass]="{'input-edit-window': !defaultStyle}" type="number" placeholder="Введите значение"  formControlName="value" (keydown.enter)="updateList()"/>
        </div>

        <div class="action-input" *ngIf="defaultStyle">
            <!-- <span class="action-field" *ngIf="defaultStyle"><i class="bi bi-x-circle reject" (click)="closeAction()"></i></span> -->
            <span class="action-field" (click)="updateList()">
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject" (click)="closeAction()">
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <!-- <span class="action-field"><i class="bi bi-check-circle approve" (click)="updateList()"></i></span> -->
        </div>
    </div>

     <!-- IF TEXTAREA -->
     <div class="input-data-edit" *ngIf="contentType == attrType.textarea">

        <div class="form-group">

            <textarea
                class="form-control"
                [ngClass]="{'input-edit-window': !defaultStyle}"
                placeholder="Введите значение" 
                formControlName="value">
            </textarea>
                
            <!-- <app-ff-textarea-lang 
                *ngIf="addinfoGroups[i].attributes[j].translation"
                hint="Укажите название значение на всех языках"
                fieldId="name"
                fieldName="name"
                fieldType="text"
                [clearField]="ffInputLangParams.name.clearField"
                [required]="ffInputLangParams.name.required"
                [inputValue]="attr.controls.attribute_value.value"
                (changeValue)="eventFnFF(i, j, $event)">
            </app-ff-textarea-lang>          -->
        </div>
        <div class="icons-action" *ngIf="defaultStyle">
            <span class="action-field" (click)="updateList()">
                <!-- <i class="bi bi-check-circle approve" ></i> -->
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject"  (click)="closeAction()">
                <!-- <i class="bi bi-x-circle reject"></i> -->
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <!-- <span class="action-field"><i class="bi bi-x-circle reject" (click)="closeAction()"></i></span> -->
        </div>
    </div>

        <!-- IF COMBOBOX (select)-->
    <div *ngIf="contentType == attrType.combobox" class="input-data-edit">

        <div class="form-group" *ngIf="!defaultStyle"> 
            <ng-select 
                id="id" 
                class="custom" 
                clearAllText="{{ 'CLEAN' | translate }}" 
                notFoundText="{{ 'NO_DATA' | translate }}"
                bindLabel="name" 
                bindValue="id" 
                formControlName="value"
                placeholder="{{ 'CERTIFICATE.CHOOSE_YOUR_VALUE' | translate }}"
                [multiple]="false"
                [loading]="loading"
                [dropdownPosition]="bottom"
                [closeOnSelect]="true"
                [items]="referencesValue"
                (change)="updateList()">
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.name}}">{{item.name}}</div>
                    </ng-template>
            </ng-select>                                                
        </div>
        <div class="form-group" *ngIf="defaultStyle"> 
            <ng-select 
                id="id" 
                class="custom"
                clearAllText="{{ 'CLEAN' | translate }}" 
                notFoundText="{{ 'NO_DATA' | translate }}"
                bindLabel="name" 
                bindValue="id" 
                formControlName="value"
                placeholder="{{ 'CERTIFICATE.CHOOSE_YOUR_VALUE' | translate }}"
                [multiple]="false"
                [dropdownPosition]="bottom"
                [loading]="loading" 
                [closeOnSelect]="true"
                [items]="referencesValue">
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.name}}">{{item.name}}</div>
                    </ng-template>
            </ng-select>                                                
        </div>
        <div class="icons-action" *ngIf="defaultStyle">
            <span class="action-field" (click)="updateList()">
                <!-- <i class="bi bi-check-circle approve" ></i> -->
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject"  (click)="closeAction()">
                <!-- <i class="bi bi-x-circle reject"></i> -->
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <!-- <span class="action-field"><i class="bi bi-x-circle reject" (click)="closeAction()"></i></span>
            <span class="action-field"><i class="bi bi-check-circle approve" (click)="updateList()"></i></span> -->
        </div>
    </div>

        <!-- IF COMBOBOX_MULTIPLE (select)-->
    <div *ngIf="contentType == attrType.combobox_multiple" class="input-data-edit">

        <div class="form-group" [ngClass]="{'input-edit-window': !defaultStyle}"  *ngIf="!defaultStyle"> 
            <ng-select 
                id="id" 
                class="custom" 
                clearAllText="{{ 'CLEAN' | translate }}" 
                notFoundText="{{ 'NO_DATA' | translate }}"
                bindLabel="name" 
                bindValue="id" 
                formControlName="value"
                placeholder="{{ 'CERTIFICATE.CHOOSE_YOUR_VALUE' | translate }}"
                [multiple]="true"
                [loading]="loading" 
                [dropdownPosition]="bottom"
                [closeOnSelect]="false"
                [items]="referencesValue"
                (change)="updateList()"
                >
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                        <span title="{{item.name}}">{{item.name}}</span>
                </ng-template>
            </ng-select>                                                
        </div>
        <div class="form-group" [ngClass]="{'input-edit-window': !defaultStyle}"  *ngIf="defaultStyle"> 
            <ng-select 
                id="id" 
                class="custom" 
                clearAllText="{{ 'CLEAN' | translate }}" 
                notFoundText="{{ 'NO_DATA' | translate }}"
                bindLabel="name" 
                bindValue="id" 
                formControlName="value"
                placeholder="{{ 'CERTIFICATE.CHOOSE_YOUR_VALUE' | translate }}"
                [multiple]="true"
                [dropdownPosition]="bottom"
                [loading]="loading" 
                [closeOnSelect]="false"
                [items]="referencesValue"
                >
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                        <span title="{{item.name}}">{{item.name}}</span>
                </ng-template>
            </ng-select>                                                
        </div>
        <div class="icons-action" *ngIf="defaultStyle">
            <span class="action-field" (click)="updateList()">
                <!-- <i class="bi bi-check-circle approve" ></i> -->
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject"  (click)="closeAction()">
                <!-- <i class="bi bi-x-circle reject"></i> -->
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
        </div>
    </div>

    <!-- IF TAG (***not error messages)-->
    <div  *ngIf="contentType == attrType.tags" [ngClass]="{'input-data-edit': defaultStyle, 'non-default-input-data-tag-create': !defaultStyle}">
    
        <div *ngIf="attributeAdditionalData != null && attributeAdditionalData.length > 0" class="table-data">

            <table class="addinfo-table form-control">
                <tbody>
                    <tr class="addinfo-row" *ngFor="let tag of attributeAdditionalData; let i = index;">
                        <td class="addinfo-cell">
                            <div class="tag-box">
                                <div class="tag-box">
                                    <div *ngIf="tag.graphics_visible" [ngStyle]="getTagStyle(tag.tag_size_detail)">
                                        <div [innerHTML]="tag.tagHtml" [color]="tag.color"></div>
                                    </div>
                                    <div *ngIf="tag.text_visible" [ngStyle]="{'color': tag.font_color}">
                                        {{tag.name}}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="addinfo-cell-actions">
                            <!-- <span *ngIf="permissionAccess.check('TAGS_CREATE')" class="action-field"><i class="bi bi-plus-circle approve" (click)="onCreateTags()"></i></span>
                            <span class="action-field"><i class="bi bi-trash reject" (click)="onDeleteTag(tag)"></i></span>    -->
                            <span class="action-field" (click)="onCreateTags()">
                                <svg-icon class="" src="/assets/images/icons/add.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </span>
                            <div class="line"></div>
                            <span class="action-field reject"  (click)="onDeleteTag(tag)">
                                <svg-icon class="" src="/assets/images/icons/trash-can.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

        <div class="icons-action" *ngIf="defaultStyle">
            <!-- <span class="action-field"><i class="bi bi-x-circle reject" (click)="closeAction()"></i></span> -->
            <!-- <span class="action-field"><i class="bi bi-check-circle approve" (click)="updateList()"></i></span> -->
            <span class="action-field" (click)="updateList()">
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject"  (click)="closeAction()">
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
        </div>

        <div *ngIf="attributeAdditionalData == null || attributeAdditionalData.length == 0">
            <!-- <span class="action-field"><i class="bi bi-plus-circle approve" (click)="onCreateTags()"></i></span> -->
            <span class="action-field" (click)="onCreateTags()">
                <svg-icon class="" src="/assets/images/icons/add.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
        </div>

    </div>

    <!-- IF FILE (***not error messages)-->
    <div  *ngIf="contentType == attrType.file" class="input-data-edit">

        <div class="upload-file-btn" *ngIf="attributeAdditionalData == null || attributeAdditionalData.length == 0">
            <ff-button-upload-files label="{{ 'Выбрать и загрузить' | translate }}" component="products" (uploadedFiles)="onCreateFile($event.result)"></ff-button-upload-files>
        </div>
    
        <div *ngIf="attributeAdditionalData != null && attributeAdditionalData.length > 0">

            <table class="addinfo-table form-control">
                <tbody>
                    <tr class="addinfo-row" *ngFor="let file of attributeAdditionalData; let i = index;">
                        <td class="addinfo-cell">{{ file.name }}</td>
                        <td class="addinfo-cell-actions">
                            <span class="action-field"  (click)="downloadFile(file)">
                                <svg-icon class="" src="/assets/images/icons/download.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </span>
                            <div class="line"></div>
                            <span class="action-field reject" (click)="onDeleteFile()">
                                <svg-icon class="" src="/assets/images/icons/trash-can.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </span>
                            <!-- <span class="action-field" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}"><i class="bi bi-download download" (click)="downloadFile(file)"></i></span>
                            <span class="action-field"><i class="bi bi-trash reject" (click)="onDeleteFile()"></i></span>    -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="icons-action" *ngIf="defaultStyle">
            <!-- <span class="action-field"><i class="bi bi-x-circle reject" (click)="closeAction()"></i></span>
            <span class="action-field"><i class="bi bi-check-circle approve" (click)="updateList()"></i></span> -->
            <span class="action-field" (click)="updateList()">
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject"  (click)="closeAction()">
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
        </div>
        

    </div>

    <!-- IF CERTIFICATE-->
    <div *ngIf="contentType == attrType.certificate" [ngClass]="{'input-data-edit': defaultStyle, 'non-default-input-data-tag-create': !defaultStyle}">

        <div *ngIf="attributeAdditionalData == null">
            <button class="btn btn-primary file-btn" type="button" *ngIf="attributeAdditionalData == null" (click)="openDialogCreateCert()">
                {{ 'FILES.ATTACH_FILE' | translate }}
            </button>
        </div>

        <div *ngIf="attributeAdditionalData != null" class="table-data">
            
            <table class="addinfo-table form-control">
                <tbody>
                    <tr class="addinfo-row">
                        <td class="addinfo-cell">
                            {{ attributeAdditionalData.file[0].name }}
                        </td>
                        <td class="addinfo-cell-actions">
                            <span class="action-field"  (click)="downloadFile(attributeAdditionalData.file[0])">
                                <svg-icon class="" src="/assets/images/icons/download.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </span>
                            <div class="line"></div>
                            <span class="action-field reject" (click)="onDeleteCertificate()">
                                <svg-icon class="" src="/assets/images/icons/trash-can.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </span>
                            <!-- <span class="action-field" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}"><i class="bi bi-download download" (click)="downloadFile(attributeAdditionalData.file[0])" matTooltip=""></i></span>
                            <span class="action-field"><i class="bi bi-trash reject" (click)="onDeleteCertificate()"></i></span>    -->
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

        <div class="icons-action"  *ngIf="defaultStyle">
            <!-- <span class="action-field"><i class="bi bi-x-circle reject" (click)="closeAction()"></i></span>
            <span class="action-field"><i class="bi bi-check-circle approve" (click)="updateList()"></i></span> -->
            <span class="action-field" (click)="updateList()">
                <svg-icon class="" src="/assets/images/icons/access.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
            <div class="line"></div>
            <span class="action-field reject"  (click)="closeAction()">
                <svg-icon class="" src="/assets/images/icons/close.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            </span>
        </div>

    </div>

    
    
</form>